module.exports = __webpack_public_path__ + "static/img/产品界面_png@2x.3639f431.png";